/**
 * This is a compiled JS file.
 * Changes here could be overwritten. 
 * Contact your Shopify developers if changes need to be made.
 */

class PaginationShowMore extends HTMLElement {
  constructor() {
    super();

    // Data attributes
    this.nextUrl = this.dataset.nextUrl;

    // Elements
    this.productGridSelector = "#ProductGridContainer > .product-grid";
    this.buttonEl = this.querySelector(".button");

    // Events
    this.buttonEl.addEventListener("click", this.handleClick.bind(this));
  }

  handleClick(event) {
    event.preventDefault();

    if (this.buttonEl.hasAttribute("disabled")) {
      return;
    }
    this.buttonEl.setAttribute("disabled", true);
    this.init();
  }

  async init() {
    // Retrieve data
    const data = await this.retrieveData();

    // Output the new products into the page markup
    this.renderContent(data);

    // Run the CollectionSelection custom element (defined in collection-selection.js)
    // to ensure the newly added elements are functional.
    new CollectionSelection(document.querySelector("collection-selection"));

    // Update the 'Show more' button – either updating its data or removing altogether
    this.updateButtonData(data);
  }

  async retrieveData() {
    try {
      const response = await fetch(this.nextUrl);
      const responseText = await response.text();
      const html = new DOMParser().parseFromString(responseText, "text/html");

      // Retrieve required elements – The new products and a new instance of the custom element.
      // This allows us to retrieve the next page's URL for when the button is clicked again.
      const newProductNodes = [
        ...html.querySelectorAll(`${this.productGridSelector} > *`),
      ];
      const newButtonNode = html.querySelector("pagination-show-more");

      // Return data in an object
      return {
        newProductNodes,
        newButtonNode,
      };
    } catch (error) {
      this.buttonEl.removeAttribute("disabled");
      console.error("Error retrieving data:", error);
      throw error;
    }
  }

  renderContent(data) {
    // Get fresh instance of the product grid
    let productGrid = document.querySelector(this.productGridSelector);

    // Append new product nodes to the product grid
    data.newProductNodes.forEach((node) => {
      productGrid.appendChild(node);
      if (node.querySelector("spark-pdp")) {
        var item = node.querySelector("spark-pdp");
        var shadow = item.shadowRoot;
        var style = document.createElement("style");
        style.type = "text/css";
        style.textContent = `
                  .spark-pdp td.variant--name {
                    display: flex!important;
                    flex-wrap: wrap;
                    word-break: keep-all!important;
                  }
                  // @media screen and (max-width: 450px){
                  //   .spark-pdp .price-variants {
                  //     overflow-x: auto;
                  //   }
                  // }
                    .multi-variant-stock-status {
                    width: 100%;
                    }
                  .product-code.sku {
                    order: -1;
                    font-weight: bold;
                    width: 100%;
                  }
                    .spark-pdp .price-summary {
                    display:none!important;
                    }
                    .spark-pdp .variant--image--large {
                      background: white;
                    }
                      .spark-pdp .product-variant-table {
                      border-color: #0e89e5;
                      border-radius: 6px;
                      border-collapse: separate;
                      border-left: 0;
                      border-right: 0;
                      border-bottom: 0;
                    }
                    .spark-pdp .stock-key .last-stock {
                      display:none;
                    }
                    .backorder-message {
                        position: absolute;
                        bottom: 5rem;
                      color: #0e00d6;

                    }

                    @media screen and (max-width: 425px){
                      .spark-table-legacy.striped.highlight.product-variant-table,
                      .spark-table-legacy-tbody {
                        display: flex;
                        flex-wrap: wrap;
                      }
                        
                      .spark-table-legacy-thead {
                        display: none;
                      }
                    }
                    @media screen and (max-width: 649px){
                      .spark-table-legacy-th.variant--image.hide-mobile + .spark-table-legacy-th {
                        border-top-left-radius: 4px;
                      }
                    }
                      @media screen and (min-width: 426px){
                      .price-variants{
                        border-radius: 4px; 
                       }
                      }
                       .spark-table-legacy-tr,
                       .spark-table-legacy-tbody,
                      .price-variants{
                        width: 100%;
                      }

                  `;
        var backOrderLeadTime = document.createElement("P");
        var leadTime = item.dataset.leadTime;
        if (leadTime) {
          backOrderLeadTime.classList.add("backorder-message");
          backOrderLeadTime.textContent = `${theme.strings.backOrderMessage}${leadTime}`;
          item.after(backOrderLeadTime);
          // style.textContent = `${style.textContent}
          //           .spark-pdp ul.stock-key{
          //               margin-bottom: 4rem;
          //           }
          //           `;
        }
        shadow.append(style);
      }
    });
  }

  updateButtonData(data) {
    if (data.newButtonNode && data.newButtonNode.nextUrl != "") {
      // If a new button exists and the nextUrl attribute is not blank, we update the
      // class's `this.nextUrl` value, in preparation for when the user clicks again.
      this.nextUrl = data.newButtonNode.dataset.nextUrl;
      this.buttonEl.removeAttribute("disabled");
    } else {
      // Else we delete the 'Show more' button
      this.remove();
    }
  }
}

if (!customElements.get("pagination-show-more")) {
  customElements.define("pagination-show-more", PaginationShowMore);
}
